export function initJobsCounter() {
    const counter = document.getElementById('collectionCounterJobs');
    if (!counter) return;

    const count = parseInt(counter.dataset.count, 10);
    if (!count || count <= 0) return;

    const specialNav = document.querySelector('.footerDCSpecialNavigation');
    if (!specialNav) return;

    const karriereLink = [...specialNav.querySelectorAll('a')].find(a =>
        /karriere|jobs/i.test(a.href)
    );
    if (!karriereLink) return;

    const badge = document.createElement('span');
    badge.className = 'navCounter';
    badge.textContent = count;
    karriereLink.appendChild(badge);
}